import { render } from "./InventoryHeader.vue?vue&type=template&id=d0f9f5ac"
import script from "./InventoryHeader.vue?vue&type=script&lang=js"
export * from "./InventoryHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__